import { render, staticRenderFns } from "./Manage-Edesignation.vue?vue&type=template&id=af2c69b6"
import script from "./Manage-Edesignation.vue?vue&type=script&lang=js"
export * from "./Manage-Edesignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports